export const authEntryHref = "/sign-up";
export const authEntryLabel = "Criar conta gratuita";
export const authEntryShortLabel = "Criar";
